import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./DownLoadLogoCard.module.scss"
type Props = {
	data: AdvancedSideAssetMainContent
	className?: string
}

const DownLoadLogoCard = (props: Props) => {
	return (
		<div className={`${styles.logoContainer} ${props.className}`}>
			{props.data.preview && (
				<NewResponsiveImage
					{...props.data.preview}
					containerClassName={styles.imageBox}
					imageClassName={styles.image}
				/>
			)}
			<ButtonSwitcher buttonsList={props.data} />
		</div>
	)
}

export default DownLoadLogoCard
